import React from 'react';
import { useCart } from './useCart';

type CartProps = ReturnType<typeof useCart>;

export const withUseCart = <P extends object>(
    Component: React.ComponentType<P & CartProps>
): React.FC<P> => {
    // Create the wrapped component
    const WrappedComponent: React.FC<P> = (props: P) => {
        const useCartProps = useCart(); // Retrieve the hook values
        return <Component {...props} {...useCartProps} />;
    };

    // Set displayName for the wrapped component
    WrappedComponent.displayName = `withUseCart(${Component.displayName || Component.name || 'Component'})`;

    return WrappedComponent;
};

export default withUseCart;
